import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {AccessoryService} from "./accessoryService";
import {AppStateService} from "../../services/appStateService";
import {PacketService} from "../packetComponent/packetService";
import {ComponentUIServiceVisibilityInterface} from "../../interfaces/ComponentUIServiceVisibilityInterface";
import {EventService} from "../../services/eventService";
import {CustomerTypeService} from "../../services/customerTypeService";
import {PriceService} from "../../services/priceService";

export class AccessoryUIService implements ComponentUIServiceVisibilityInterface
{
    private uiService: UIService;
    private productDataService: ProductDataService;
    public accessoryService: AccessoryService;
    private productDataStore: ProductDataStore;
    private appStateService: AppStateService;
    private eventService: EventService;
    private customerTypeService: CustomerTypeService;
    private priceService: PriceService;

    private FIXED_IN_SASH_ACCESSORY_TYPE = 2;

    constructor()
    {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.accessoryService = new AccessoryService();
        this.productDataStore = new ProductDataStore();
        this.appStateService = new AppStateService();
        this.eventService = new EventService();
        this.customerTypeService = new CustomerTypeService();
        this.priceService = new PriceService();

        this.refreshComponentTemplate();
    }

    componentDontHaveOptions(): boolean {
        return this.productDataStore.getAvailableOptionsByName('accessory').length === 0;
    }

    public refreshComponentTemplate()
    {
        this.appStateService.setAppSettingTemplateFlag('accessories', 'packetSelectedNotice', PacketService.isAnyPacketSelected());
        this.appStateService.setAppSettingTemplateFlag('accessories', 'showIncludedOptions', this.accessoryService.hasIncludedAccessories());
        this.appStateService.setAppSettingTemplateFlag('accessories', 'showAdditionalOptions', this.accessoryService.hasAdditionalAccessories());
        this.uiService.refreshElementsInModule('accessories');
    }

    public refreshSelectedOptions()
    {
        const selected = this.productDataStore.getSelectedOptionByName('accessories');
        this.uiService.resetSelectionsByPartName('additionalAccessory');
        this.uiService.setSelectedOptions('additionalAccessory', selected);
    }

    public initialize()
    {
        if (this.componentDontHaveOptions()) {
            this.appStateService.setAppSettingTemplateFlag('app', 'accessoriesComponent', false);
            this.uiService.refreshElementsInModule('app');
            this.uiService.hideConfiguratorMenuElement('accessories');
            return;
        }

        this.accessoryService.validate();
        this.initializeAdditionalAccessories(
            this.productDataStore.getAvailableOptionsByName(
                'accessory'
            )
        );
        this.initializeIncludedAccessories(
            this.productDataStore.getAvailableOptionsByName(
                'includedAccessories'
            )
        );
        this.accessoryService.refreshComponentTemplate();
        this.initializeModal();
        this.populatePreview();

        this.eventService.getTarget().addEventListener('updateAccessoriesPrices', (data) => {
            this.refreshPrices();
        });

        this.eventService.getTarget().addEventListener('sizeChange', (data) => {
            this.accessoryService.validate();
            this.refreshAdditionalAccessories();
        });
    }

    private populatePreview()
    {
        var preview = [];

        const elements = this.uiService.getElementByActionName('nf-selected-accessories-preview');
        const accessories = this.productDataStore.getAvailableOptionsByName(
            'accessory'
        );
        const includedAccessories = this.productDataStore.getAvailableOptionsByName(
            'includedAccessories'
        );

        elements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });

        accessories.forEach((accessory) => {
            if (this.productDataStore.getSelectedOptionIdByName('accessories').includes(accessory.id)) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            accessory.attributes.name
                        )
                    );

                preview.push(element);
            }
        });
        includedAccessories.forEach((accessory) => {
            if (this.productDataStore.getSelectedOptionIdByName('includedAccessories').includes(accessory.id)) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            accessory.attributes.name
                        )
                    );

                preview.push(element);
            }
        });

        elements.forEach((element) => {
            element.append(...Array.from(preview));
        });
    }

    private refreshAdditionalAccessories()
    {
        const accessories = this.productDataStore.getAvailableOptionsByName(
            'accessory'
        );

        accessories.forEach((accessory) => {
            const elements = [
                this.uiService.getElementByPartNameAndId('additionalAccessory', accessory.id),
                this.uiService.getElementByPartNameAndId('additionalAccessoryModal', accessory.id),
            ];
            elements.forEach((element) => {
                if (element === null) {
                    return;
                }
                if (accessory.attributes.isBlocked) {
                    this.uiService.disableOption(element);
                } else {
                    this.uiService.enableOption(element);
                }
                if (this.productDataStore.getSelectedOptionIdByName('accessories').includes(accessory.id)) {
                    element.classList.add('--checked-item');
                    this.uiService.setSelectedOption(element);
                } else {
                    element.classList.remove('--checked-item');
                }
            });
        });
    }

    private refreshIncludedAccessories()
    {
        const includedAccessories = this.productDataStore.getAvailableOptionsByName(
            'includedAccessories'
        );

        includedAccessories.forEach((accessory) => {
            const elements = [
                this.uiService.getElementByPartNameAndId('includedAccessory', accessory.id),
                this.uiService.getElementByPartNameAndId('includedAccessoryModal', accessory.id),
            ];
            elements.forEach((element) => {
                if (accessory.attributes.isBlocked) {
                    this.uiService.disableOption(element);
                } else {
                    this.uiService.enableOption(element);
                }
                if (this.productDataStore.getSelectedOptionIdByName('includedAccessories').includes(accessory.id)) {
                    this.uiService.setSelectedOption(element);
                } else {
                    element.classList.remove('--checked-item');
                }
            });
        });
    }

    private initializeModal()
    {
        const closeButton = document
            .querySelector('.configuratorComponent[nf-component-name="accessories"]')
            .querySelector(`[nf-action="closeAccessoryDetailsModal"]`);

        closeButton.addEventListener('click', (event: any) => {
            this.appStateService.setAppSettingTemplateFlag('accessories', 'accessoryDetailsModal', false);
            this.uiService.refreshElementsInModule('accessories');
        });
    }

    private initializeIncludedAccessories(accessories)
    {
        accessories.forEach((accessory) => {

            const elements = [
                this.createAccessoryOption(accessory, true),
                this.createAccessoryOption(accessory, true, true),
            ];
            elements.forEach((element) => {
                if (this.productDataStore.getSelectedOptionIdByName('includedAccessories').includes(accessory.id)) {
                    this.uiService.setSelectedOption(element);
                }
            });
        });
    }

    private initializeAdditionalAccessories(accessories)
    {
        accessories.forEach((accessory) => {
            // @todo: do we need to select default accessories here or are they already selected on conf object?
            if (accessory.attributes.isDefault) {
                this.accessoryService.select(accessory.id);
            }
            const elements = [
                this.createAccessoryOption(accessory),
                this.createAccessoryOption(accessory, false, true),
            ];
            elements.forEach((element) => {
                if (this.productDataStore.getSelectedOptionIdByName('accessories').includes(accessory.id)) {
                    this.uiService.setSelectedOption(element);
                }

                element.addEventListener('click', (event: any) => {
                    this.accessoryService.toggle(accessory.id);
                    this.accessoryService.validate();
                    this.refreshAdditionalAccessories();
                    this.populatePreview();
                    this.productDataService.refreshPrice();
                    if (accessory.attributes.accessoryType === this.FIXED_IN_SASH_ACCESSORY_TYPE) {
                        this.productDataService.updateProductDrawing();
                    }
                });
            });
        });
    }

    private createAccessoryOption(accessory, isIncluded = false, modal = false)
    {
        const type = isIncluded === true ?
            'includedAccessory' + (modal ? 'Modal' : '') :
            'additionalAccessory' + (modal ? 'Modal' : '') ;

        const option = this.uiService.createConfiguratorOption(type);
        const readMoreButton = option.querySelector(`[nf-action="openAccessoryReadMoreModal"]`);

        if (accessory.attributes.isBlocked) {
            option.classList.add('--blocked');
        }
        if (readMoreButton !== null) {
            readMoreButton.classList.remove('--hiddenTemplateElement');
            readMoreButton.addEventListener('click', (event: any) => {
                this.uiService.setAttributeToElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'modalImg',
                        document.querySelector(
                            '.configuratorComponent[nf-component-name="accessories"]'
                        ),
                    ),
                    'src',
                    accessory.attributes.imgSrc
                );
                this.uiService.replaceTextInElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'modalTitle',
                        document.querySelector(
                            '.configuratorComponent[nf-component-name="accessories"]'
                        ),
                    ),
                    accessory.attributes.name
                );
                if (
                    accessory.attributes.modalContent !== null &&
                    accessory.attributes.modalContent !== ''
                ) {
                    this.uiService.replaceTextInElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'modalContent',
                            document.querySelector(
                                '.configuratorComponent[nf-component-name="accessories"]'
                            ),
                        ),
                        accessory.attributes.modalContent
                    );
                }
                this.appStateService.setAppSettingTemplateFlag('accessories', 'accessoryDetailsModal', true);
                this.uiService.refreshElementsInModule('accessories');

                event.preventDefault();
                event.stopPropagation();

                return false;
            });
        }
        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            accessory.id
        );
        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'img',
                option,
            ),
            'src',
            accessory.attributes.imgSrc
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'name',
                option,
            ),
            accessory.attributes.name
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'price',
                option,
            ),
            '+' + (this.getPrice(accessory) ?? 0) + ' kr'
        );
        if (accessory.attributes.isDefault || isIncluded) {
            option.querySelectorAll('.confAccessory__content-item-description-price').forEach((element) => {
                element.classList.add('--hiddenTemplateElement')
            });
        }

        return option;
    }

    private refreshPrices()
    {
        const accessories = this.appStateService.getPrices().filter(function(part) {
            return part.type && part.type === 'accessory';
        });

        [
            'additionalAccessory',
            'additionalAccessoryModal',
            'packetAccessory',
        ]
        .forEach((element) => {
            accessories.forEach((accessory) => {
                const parent = this.uiService.getElementByPartNameAndId(
                    element,
                    accessory.id
                );
                if (parent === null) {
                    return;
                }
                this.uiService.replaceTextInElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'price',
                        parent,
                    ),
                    '+' + (this.getPrice(accessory) ?? 0) + ' kr'
                );
            });
        });
    }

    public getPrice(accessory)
    {
        if (this.customerTypeService.isB2bCustomer()) {
            return accessory.attributes.netPriceAfterDiscount;
        }
        return accessory.attributes.priceAfterDiscount;
    }
}
